import { createAction } from '@reduxjs/toolkit';
import { types } from './types';
import { ICreateAffiliatePayload, IGetAffiliatesPayload, IAffiliateCode } from './types';

export const createAffiliate = createAction<ICreateAffiliatePayload>(types.CREATE_AFFILIATE);
export const createAffiliateSuccess = createAction<IAffiliateCode>(types.CREATE_AFFILIATE_SUCCESS);
export const createAffiliateFailed = createAction<string>(types.CREATE_AFFILIATE_FAILED);

export const getAffiliates = createAction<IGetAffiliatesPayload>(types.GET_AFFILIATES);
export const getAffiliatesSuccess = createAction<any>(types.GET_AFFILIATES_SUCCESS);
export const getAffiliatesFailed = createAction<string>(types.GET_AFFILIATES_FAILED);

export const deleteAffiliate = createAction<string>(types.DELETE_AFFILIATE);
export const deleteAffiliateSuccess = createAction<string>(types.DELETE_AFFILIATE_SUCCESS);
export const deleteAffiliateFailed = createAction<string>(types.DELETE_AFFILIATE_FAILED);
